// src/editor/tiptapExtensions.js
import { Color } from '@tiptap/extension-color';
import Link from '@tiptap/extension-link';
import ListItem from '@tiptap/extension-list-item';
import Placeholder from '@tiptap/extension-placeholder';
import TextAlign from '@tiptap/extension-text-align';
import TextStyle from '@tiptap/extension-text-style';
import Underline from '@tiptap/extension-underline';
import StarterKit from '@tiptap/starter-kit';
import { ImageResize } from './ImageResize';

export const tiptapExtensions = [
  Color.configure({ types: [TextStyle?.name, ListItem?.name] }),
  TextStyle.configure({ types: [ListItem?.name] }),
  StarterKit.configure({
    bulletList: {
      keepMarks: true,
      keepAttributes: false,
    },
    orderedList: {
      keepMarks: true,
      keepAttributes: false,
    },
  }),
  ImageResize,
  Placeholder.configure({
    placeholder: 'Message ...',
  }),
  TextAlign.configure({
    types: ['heading', 'paragraph'],
  }),
  Link,
  Underline,
];
